import delay from "./delay";

export interface AnimateOptions {
  duration: number,
  delay?: number,
  easing?: (t: number) => number,
}

export default async function animate (handler: (t: number) => void, options: AnimateOptions): Promise<void> {
  const easing = options.easing || ((t: number) => t); // todo: replace with easingInOut or linear
  const duration = options.duration;

  if (options.delay) { await delay(options.delay); }

  const startTime = performance.now();
  return new Promise((resolve) => {
    function tick (currentTime: number): void {
      const elapsedTime = currentTime - startTime;

      if (elapsedTime < duration) {
        const t = easing(elapsedTime / duration);

        handler(t);
        requestAnimationFrame(tick);
      } else {
        handler(1);
        resolve();
      }
    }

    requestAnimationFrame(tick);
  });
}
